import { useEffect, useRef, useState } from 'react';
import DevelopDatabaseEdit from './DevelopDatabaseEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';

/**
 * 组件 DevelopDatabase 
 * @param props 
 * @returns 
 */
const DevelopDatabase = (props: any) => {
    const apiId = 'developDatabase';

    //刷新变量
    const [refresh, setRefresh] = useState(0);
    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);
    /** 刷新数据 */
    let initData: any;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initData = ref.current.initData;
        }
        // const fetchData = async () => {
        // };
        // fetchData();
        if (refresh !== 0) {
            initData();
        }
    }, [refresh]); //初始化数据

    /** 表头内容 */
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'databaseName',
        },
        {
            title: '项目',
            dataIndex: 'developProjects',
            render: (text: any) => (typeof text !== 'undefined' ?
                text.projectName : '')
        },
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '开发数据库',
        apiId,
        columns,
        showStates: true,
        EditComponent: DevelopDatabaseEdit
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default DevelopDatabase;